var _defs, _path, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-800a37e0-93f5-4ecd-af88-6bf4f6079767",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-b5d0fd70-ab7f-4758-a12d-b787bf798844 {\n        fill: #f2f2f2;\n      }\n\n      .uuid-94ae869c-0d1d-40fc-85ca-1c3171725563 {\n        fill: none;\n        stroke: #f2f2f2;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-94ae869c-0d1d-40fc-85ca-1c3171725563",
    d: "M10.75,13.51c.93-1.96,2.93-3.32,5.25-3.32,3.21,0,5.81,2.6,5.81,5.81s-2.6,5.81-5.81,5.81"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-b5d0fd70-ab7f-4758-a12d-b787bf798844",
    points: "13.87 13.15 10.4 17.52 8.35 12.33 13.87 13.15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default __webpack_public_path__ + "static/media/Redo.a56e6aceb620a59223e92ff211ff5716.svg";
export { ForwardRef as ReactComponent };